import './HighlighterHOC.css';
import Highlighter from 'react-highlight-words';
import React from 'react';
var getFilteredItem = function getFilteredItem(item) {
  var specialSymbols = ["*", "?", "(", ")", "[", "]", "{", "}", "+", "\\"];
  var copyItem = item.slice();
  var isSpecialSymbolExist = specialSymbols.some(function (symbol) {
    return copyItem.includes(symbol);
  });
  if (isSpecialSymbolExist) {
    return copyItem.split("").map(function (letter) {
      var isLetterSpecialSymbol = specialSymbols.some(function (symbol) {
        return letter.includes(symbol);
      });
      if (isLetterSpecialSymbol) {
        return "\\".concat(letter);
      }
      return letter;
    }).join("");
  }
  return copyItem;
};
export var HighlighterHOC = function HighlighterHOC(_ref) {
  var searchString = _ref.searchString,
    text = _ref.text;
  if (typeof searchString === 'string') {
    var filteredSearchString = getFilteredItem(searchString);
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(commonStyles)
    }, /*#__PURE__*/React.createElement(Highlighter, {
      highlightClassName: "marked",
      searchWords: [filteredSearchString],
      textToHighlight: text
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, text);
};
export var commonStyles = "c88h133";